import React from 'react';
import Aux from '../../hoc/ReactAux';
import './FourOFourContainer.css';

const FourOFourContainer = () => (
  <Aux>
    <div>
      <img className="bg" alt="" src="./images/CorollaHeroMainFilter.jpg" />
      <div className="caption four0four">
        <img className="captionIMGCar" alt="" src="./images/CorollaHeroCloseUp.jpg" />
        <div className="caption2">
          <img className="captionIMGOval" alt="" src="./images/RedOval.png" />
        </div>
        <div className="caption3">
          <img className="captionIMGThumb spanner404" alt="" src="./images/spanner404.png" />
        </div>
        <br />
        <div className="captionLower">
          {
            <div>
              <span className="upperText">
                <div>Hmm, we can't find that page</div>
              </span>
              <span className="middleText">
                This is a 404 error, that means the page requested doesn't exist.
                <br />
                Please contact your dealer if you need assistance.
              </span>
            </div>
          }
        </div>
      </div>
    </div>
  </Aux>
);

export default FourOFourContainer;



// WEBPACK FOOTER //
// ./src/containers/Redirect/FourOFourContainer.js